import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { TFunction } from '@/lib/i18n';

/**
 * 公的 ID 機能で複数ルートをまたいで共用する語彙・表示ロジック。
 * ルート private（`-`）フォルダに閉じず、feature 直下の `-shared` に置いて
 * add / import-csv / $id / _list から参照する（ルート跨ぎの reach-in を避ける）。
 */

/** 公的 ID 種別（登録・CSV 取込導線で共用） */
export const PublicIdType = {
  NATIONAL_ID: 'NATIONAL_ID'
} as const;
export type PublicIdType = EnumUnion<typeof PublicIdType>;

/**
 * 国民 ID（category=NATIONAL_ID）の subtype。list contract の subtype に対応。
 * subtype 文字列の直書き散在を防ぐ唯一の定義元とする。
 */
export const NationalIdSubtype = {
  MY_NUMBER: 'MY_NUMBER',
  NATIONAL_REGISTRATION_IDENTITY_CARD: 'NATIONAL_REGISTRATION_IDENTITY_CARD'
} as const;
export type NationalIdSubtype = EnumUnion<typeof NationalIdSubtype>;

/**
 * 公的 ID の subtype をユーザー向け表示名へ変換する共有ロジック。
 * 一覧カラム・詳細ヘッダー・パンくずで共用し、mapping の二重実装と subtype 直書きを防ぐ。
 * 未知の subtype はそのまま、null/undefined は '-' を返す。
 * @param t keyPrefix='pages.publicIds.detail' で束縛した翻訳関数
 */
export const getPublicIdSubtypeLabel = (subtype: string | null | undefined, t: TFunction<'translation', 'pages.publicIds.detail'>): string => {
  switch (subtype) {
    case NationalIdSubtype.MY_NUMBER:
      return t('sections.myNumber');
    case NationalIdSubtype.NATIONAL_REGISTRATION_IDENTITY_CARD:
      return t('sections.nationalRegistrationIdentityCard');
    default:
      return subtype ?? '-';
  }
};